export const request = (type: string): string => `${type}_REQUEST`;
export const success = (type: string): string => `${type}_SUCCESS`;
export const error = (type: string): string => `${type}_ERROR`;